import axios from "axios";

const upload_url = process.env.NEXT_PUBLIC_BACKEND_URI + "/upload/post-media";

export const uploadImage = async (
  files: File[],
  userId: string,
  onFileProgress?: (percent: number) => void
): Promise<{ url: string; media_id: string }> => {
  const formData = new FormData();

  files.forEach((file) => formData.append("files", file));
  formData.append("user_id", userId);

  try {
    const response = await axios.post(upload_url!, formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total && onFileProgress) {
          const percentComplete = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onFileProgress(percentComplete);
        }
      },
    });

    const result = response.data;
    return {
      url: result.url,
      media_id: result.media_id,
    };
  } catch (error) {
    console.error("Upload error:", error);
    throw new Error("Image upload failed");
  }
};
